import { isTauri } from './tauri';

// Opens a link the way "open in a new tab" does on the web.
//
// A desktop app (Tauri) has no browser tabs, and window.open(url, '_blank')
// does nothing there. So on desktop we open internal app routes (e.g.
// /storemap/:id "View Neighborhood") in a NEW Atlas window instead — you can
// have several open at once, which is the multi-view experience the web tab
// gives. External pages open in a plain framed window.
//
// On the web this is unchanged: it still opens a real browser tab.

let seq = 0;

export function openLink(url: string): void {
  if (!isTauri()) {
    window.open(url, '_blank', 'noopener,noreferrer');
    return;
  }

  // Resolve relative routes (e.g. "/storemap/123") against the app origin, and
  // decide whether the target is one of our own pages or an external site.
  let absolute = url;
  let internal = false;
  try {
    const u = new URL(url, window.location.origin);
    absolute = u.toString();
    internal = u.origin === window.location.origin;
  } catch {
    /* leave url as-is */
  }

  seq += 1;
  const label = `atlas-view-${Date.now()}-${seq}`;

  import('@tauri-apps/api/webviewWindow')
    .then(({ WebviewWindow }) => {
      const win = new WebviewWindow(label, {
        url: absolute,
        title: 'Atlas',
        width: 1200,
        height: 800,
        center: true,
        resizable: true,
        // Our own pages render the custom React title bar, so open them
        // frameless (with shadow for rounded corners). External pages keep a
        // native window frame so they stay usable.
        decorations: !internal,
        shadow: true,
      });
      // If window creation fails for any reason, fall back to the old behavior.
      win.once('tauri://error', () => window.open(url, '_blank'));
    })
    .catch(() => window.open(url, '_blank'));
}
